import React from 'react'

export enum Types {
	default = 'default',
	warning = 'warning',
	error = 'error'
}

export type MarqueeProps = {
	type: keyof typeof Types
	component: React.ReactElement
	countElement?: number
	wrapperClassName?: string
}
